<template>
  <div class="cmp-input-filter">
    <input
      type="text"
      class="input-small"
      :placeholder="i18nJS.command.filter"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>
<script>
export default {
  name: 'inputFilter',
  props: {
    value: String,
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
};
</script>
<style lang="scss" scoped>
.cmp-input-filter {
  padding-right: 10px;
}
input {
  box-sizing: border-box;
  width: 100%;
}
</style>
